
    import Vue from 'vue';
    import Component from "vue-class-component";
    import {
        factory,
        QualificationRecordResultModel, QualificationRecordsClient, ResultError, SetResultAsFailedModel
    } from "@/api-client";
    import {BModal} from "bootstrap-vue";
    import {Prop} from "vue-property-decorator";
    import toasts from "@/components/Toasts";
    import {isNullOrWhiteSpace} from "@/extensions/string.helpers";

    @Component
    export default class SetQualificationResultAsFailedModal extends Vue {
        @Prop({required: true})
        modelType!: { new(): SetResultAsFailedModel };
        @Prop({required: true})
        recordId!: string;
        
        result: QualificationRecordResultModel = factory.create(QualificationRecordResultModel);
        validationErrors: ResultError = factory.create(ResultError);
        
        $refs!: {
            modal: BModal;
        };
        
        public open(result: QualificationRecordResultModel){
            this.validationErrors = factory.create(ResultError);
            this.result = QualificationRecordResultModel.fromJS(result);
            this.$refs.modal.show();
        }

        async submit() {
            const model = factory.create(this.modelType);
            model.recordId = this.recordId;
            model.seafarerId = this.result.seafarer!.id;
            model.comment = this.result.comment;
            await new QualificationRecordsClient().setResultFailed(model).then(() => {
                this.$emit("results-updated");
                this.close();
                toasts.success(this.$ls.Global_Toast_SaveSuccess);
            }).catch(error => this.setValidationErrors(error, this.$ls.Global_Toast_FormSaveFailure));
        }

        close(){
            this.$refs.modal.hide();
        }
    
        get isButtonDisabled(): boolean {
            return isNullOrWhiteSpace(this.result.comment);
        }
    }
